@if (userInfoService.info$ | async; as user) {
  <div class="avatar current pointer" [matMenuTriggerFor]="menu">
    {{ user.firstName[0] + user.lastName[0] }}
  </div>
}
<ng-template #noUser>
  <button
    mat-icon-button
    aria-label="button with expand menu icon"
    [matMenuTriggerFor]="menu">
    <mat-icon>expand_more</mat-icon>
  </button>
</ng-template>
<mat-menu #menu>
  <button routerLink="account/settings" mat-menu-item>
    <mat-icon>manage_accounts</mat-icon>
    <span><ng-container i18n>Account</ng-container></span>
  </button>
  <button (click)="logout()" mat-menu-item>
    <mat-icon>logout</mat-icon>
    <span><ng-container i18n>Logout</ng-container></span>
  </button>
</mat-menu>
